<template>
  <div class="card card-box convention-carte">
    <div class="convention-entete">
      <div>
        <h4 class="mb-1">Travailleurs et familles</h4>
        <span class="text-grey">{{ resume }}</span>
      </div>
      <button type="button" class="btn btn-primary btn-radius" @click="ouvrir(null, null)"><i class="ic-plus h-13p"></i> Ajouter un travailleur</button>
    </div>
    <p class="text-grey font-13">Les travailleurs enregistrés deviennent patients à leur première venue : l’accueil les retrouve par matricule ou par nom.
      La famille a le même taux que le travailleur, sauf taux particulier.</p>

    <div class="convention-filtres">
      <input v-model.trim="filtre" type="search" class="input-secondary-light" placeholder="Rechercher un matricule, un nom, un prénom" aria-label="Rechercher un travailleur">
      <select v-model="etat" class="input-secondary-light" aria-label="Filtrer par état">
        <option value="tous">Tous</option>
        <option value="couverts">Couverts</option>
        <option value="desactives">Désactivés</option>
      </select>
    </div>

    <div v-if="erreur && !formulaire" class="alert alert-danger" role="alert">{{ erreur }}</div>
    <div v-if="chargement" class="text-grey">Chargement des travailleurs…</div>
    <div v-else-if="!travailleurs.length" class="convention-vide">Aucun travailleur enregistré pour le moment.</div>
    <div v-else class="table-responsive">
      <table class="table convention-table">
        <thead><tr><th>Matricule</th><th>Nom et prénoms</th><th>Téléphone</th><th>Taux</th><th>État</th><th></th></tr></thead>
        <tbody v-for="t in visibles" :key="t.id">
          <tr class="convention-travailleur">
            <td>{{ t.matricule || '—' }}</td>
            <td>
              <button type="button" class="btn btn-link p-0 convention-deplier" :aria-expanded="ouverts[t.id] ? 'true' : 'false'" @click="basculer(t.id)">
                <span aria-hidden="true">{{ ouverts[t.id] ? '▾' : '▸' }}</span> {{ t.nom }} {{ t.prenoms }}
              </button>
              <small class="d-block text-grey">{{ libelleFamille(t) }}</small>
            </td>
            <td>{{ t.telephone || '—' }}</td>
            <td>{{ libelleTauxMembre(t, null) }}</td>
            <td>
              <span :class="['badge', t.couvert ? 'badge-success' : 'badge-secondary']">{{ t.couvert ? 'Couvert' : 'Désactivé' }}</span>
              <span v-if="t.patient_id" class="badge badge-light">Déjà venu</span>
            </td>
            <td class="convention-boutons">
              <button type="button" class="btn btn-outline-primary btn-sm" @click="ouvrir(null, t)">+ Famille</button>
              <button type="button" class="btn btn-outline-secondary btn-sm" @click="ouvrir(t, null)">Modifier</button>
              <button type="button" class="btn btn-outline-secondary btn-sm" :disabled="occupe === t.id" @click="activer(t)">{{ t.actif ? 'Désactiver' : 'Réactiver' }}</button>
              <button v-if="peutSupprimer(t)" type="button" :class="['btn btn-sm', aSupprimer === t.id ? 'btn-danger' : 'btn-outline-danger']" @click="supprimer(t)">
                {{ aSupprimer === t.id ? 'Confirmer' : 'Supprimer' }}</button>
            </td>
          </tr>
          <template v-if="ouverts[t.id]">
            <tr v-for="m in t.famille" :key="m.id" class="convention-membre">
              <td>{{ m.matricule_propre || '—' }}</td>
              <td>{{ m.nom }} {{ m.prenoms }}<small class="d-block text-grey">{{ m.lien_libelle || libelleLien(m.lien) }}</small></td>
              <td>—</td>
              <td>{{ libelleTauxMembre(m, t) }}</td>
              <td>
                <span :class="['badge', m.couvert ? 'badge-success' : 'badge-secondary']">{{ m.couvert ? 'Couvert' : 'Désactivé' }}</span>
                <span v-if="m.patient_id" class="badge badge-light">Déjà venu</span>
              </td>
              <td class="convention-boutons">
                <button type="button" class="btn btn-outline-secondary btn-sm" @click="ouvrir(m, t)">Modifier</button>
                <button type="button" class="btn btn-outline-secondary btn-sm" :disabled="occupe === m.id" @click="activer(m)">{{ m.actif ? 'Désactiver' : 'Réactiver' }}</button>
                <button v-if="!m.patient_id" type="button" :class="['btn btn-sm', aSupprimer === m.id ? 'btn-danger' : 'btn-outline-danger']" @click="supprimer(m)">
                  {{ aSupprimer === m.id ? 'Confirmer' : 'Supprimer' }}</button>
              </td>
            </tr>
            <tr v-if="!t.famille.length" class="convention-membre"><td colspan="6" class="text-grey">Aucun membre de famille enregistré.</td></tr>
          </template>
        </tbody>
        <tbody v-if="!filtres.length"><tr><td colspan="6" class="text-grey">Aucun travailleur ne correspond.</td></tr></tbody>
      </table>
      <button v-if="filtres.length > limite" type="button" class="btn btn-link" @click="limite += 50">Afficher plus ({{ filtres.length - limite }})</button>
    </div>

    <div v-if="formulaire" class="convention-fenetre" role="dialog" aria-modal="true" aria-labelledby="membre-titre">
      <form class="convention-fenetre-contenu" novalidate @submit.prevent="enregistrer">
        <div class="convention-fenetre-entete">
          <h4 id="membre-titre" class="mb-0">{{ titreFormulaire }}</h4>
          <button type="button" class="btn btn-link convention-fermer" aria-label="Fermer" @click="fermer">×</button>
        </div>
        <div v-if="formulaire.travailleur_id" class="form-group">
          <span class="d-block mb-1">Lien avec le travailleur *</span>
          <div class="convention-liens">
            <label v-for="lien in liens" :key="lien.valeur"><input v-model="formulaire.lien" type="radio" name="membre-lien" :value="lien.valeur"> {{ lien.libelle }}</label>
          </div>
        </div>
        <!-- Parent ou autre : préciser de qui il s'agit (05/10/2026). -->
        <div v-if="formulaire.travailleur_id && avecFiliation(formulaire.lien)" class="form-row">
          <div class="form-group col-md-6"><label for="membre-filiation">Filiation *</label>
            <input id="membre-filiation" v-model.trim="formulaire.filiation" class="input-secondary-light" maxlength="60" list="membre-filiations"
              :placeholder="formulaire.lien === 'parent' ? 'Père, mère' : 'Tante, oncle, cousin…'">
            <datalist id="membre-filiations">
              <option v-for="choix in filiationsProposees(formulaire.lien)" :key="choix" :value="choix"></option>
            </datalist></div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-4"><label for="membre-matricule">Matricule</label>
            <input id="membre-matricule" v-model.trim="formulaire.matricule" class="input-secondary-light" maxlength="60"
              :placeholder="formulaire.travailleur_id ? 'Celui du travailleur' : ''"></div>
          <div class="form-group col-md-4"><label for="membre-nom">Nom *</label>
            <input id="membre-nom" v-model.trim="formulaire.nom" class="input-secondary-light" maxlength="120" required></div>
          <div class="form-group col-md-4"><label for="membre-prenoms">Prénoms</label>
            <input id="membre-prenoms" v-model.trim="formulaire.prenoms" class="input-secondary-light" maxlength="160"></div>
        </div>
        <!-- Identité complète : tout le formulaire patient se remplit à l'accueil dès qu'on choisit la personne (04/10/2026). -->
        <div class="form-row">
          <div class="form-group col-md-4"><label for="membre-sexe">Sexe</label>
            <select id="membre-sexe" v-model="formulaire.sexe_id" class="input-secondary-light">
              <option :value="null">Non renseigné</option>
              <option v-for="sexe in sexes" :key="sexe.id" :value="sexe.id">{{ sexe.specificatif }}</option>
            </select></div>
          <div class="form-group col-md-4"><label for="membre-naissance">Date de naissance</label>
            <input id="membre-naissance" v-model="formulaire.date_naissance" type="date" class="input-secondary-light" :max="aujourdhui"></div>
          <div class="form-group col-md-4 custom-tel-flag"><label for="membre-telephone">Téléphone</label>
            <vue-tel-input :key="'membre-tel-' + paysParDefaut" id="membre-telephone" v-model="formulaire.telephone" class="input-secondary-light"
              :inputOptions="optionsTelephone" :defaultCountry="paysParDefaut" @country-changed="paysChoisi"></vue-tel-input></div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6"><label for="membre-profession">Profession</label>
            <input id="membre-profession" v-model.trim="formulaire.profession" class="input-secondary-light" maxlength="120"></div>
          <div class="form-group col-md-6"><label for="membre-quartier">Quartier</label>
            <input id="membre-quartier" v-model.trim="formulaire.quartier" class="input-secondary-light" maxlength="120"></div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6"><label for="membre-taux">Taux particulier</label>
            <div class="input-container"><input id="membre-taux" v-model.trim="formulaire.taux" class="input-secondary-light" inputmode="decimal"
              :placeholder="formulaire.travailleur_id ? 'Même taux que le travailleur' : 'Taux du contrat'">
              <span class="input-icon ic-secondary font-wgh-900">%</span></div>
            <small class="text-grey">Laissez vide dans le cas normal.</small></div>
        </div>
        <p v-if="erreur" class="text-danger" role="alert">{{ erreur }}</p>
        <div class="text-right">
          <button type="button" class="btn btn-secondary-light-o btn-radius" @click="fermer">Annuler</button>
          <button type="submit" class="btn btn-primary btn-radius ml-2" :disabled="enregistrement">{{ enregistrement ? 'Enregistrement…' : 'Enregistrer' }}</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ConventionsApi from '@/api/parametres/_conventions'
import { tauxValide } from '../taux-assurance'
import { separerTelephone, assemblerTelephone } from './telephone'

const LIENS = [
  { valeur: 'conjoint', libelle: 'Conjoint(e)' },
  { valeur: 'enfant', libelle: 'Enfant' },
  { valeur: 'parent', libelle: 'Parent' },
  { valeur: 'autre', libelle: 'Autre' },
]
// Parent ou autre : la filiation précise de qui il s'agit (05/10/2026).
const LIENS_AVEC_FILIATION = ['parent', 'autre']

function normaliser(texte) {
  return String(texte || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

function messageErreur(erreur, defaut) {
  const donnees = erreur && erreur.response ? erreur.response.data : null
  if (donnees && donnees.errors) {
    const premiers = Object.keys(donnees.errors).map(cle => donnees.errors[cle][0])
    if (premiers.length) return premiers[0]
  }
  return donnees && donnees.message ? donnees.message : defaut
}

// Travailleurs pré-enregistrés d'une société à convention directe et leur famille (04/10/2026).
export default {
  name: 'convention-travailleurs',
  props: {
    assuranceId: { type: [String, Number], required: true },
  },
  data() {
    return {
      liens: LIENS, travailleurs: [], chargement: true, erreur: '', filtre: '', etat: 'tous', limite: 50,
      ouverts: {}, formulaire: null, enregistrement: false, occupe: null, aSupprimer: null,
      sexes: [], optionsTelephone: { placeholder: 'Ex. 90 00 00 00', maxlength: 15 },
    }
  },
  computed: {
    // Drapeau défini dans les paramètres de l'établissement (mixin global).
    paysParDefaut() {
      return this.default_country_code || ''
    },
    aujourdhui() {
      return new Date().toISOString().slice(0, 10)
    },
    resume() {
      const famille = this.travailleurs.reduce((total, t) => total + t.famille.length, 0)
      const desactives = this.travailleurs.filter(t => !t.couvert).length
      return this.travailleurs.length + ' travailleur(s) · ' + famille + ' membre(s) de famille · ' + desactives + ' désactivé(s)'
    },
    filtres() {
      const mots = normaliser(this.filtre).split(/\s+/).filter(Boolean)
      return this.travailleurs.filter(t => {
        if (this.etat === 'couverts' && !t.couvert) return false
        if (this.etat === 'desactives' && t.couvert) return false
        if (!mots.length) return true
        const texte = normaliser([t.matricule, t.nom, t.prenoms, t.telephone]
          .concat(t.famille.map(m => m.nom + ' ' + (m.prenoms || '') + ' ' + (m.matricule_propre || ''))).join(' '))
        return mots.every(mot => texte.indexOf(mot) >= 0)
      })
    },
    visibles() {
      return this.filtres.slice(0, this.limite)
    },
    titreFormulaire() {
      const f = this.formulaire
      if (!f.travailleur_id) return f.id ? 'Modifier le travailleur' : 'Nouveau travailleur'
      return (f.id ? 'Modifier un membre de la famille de ' : 'Ajouter un membre de la famille de ') + f.nom_travailleur
    },
  },
  mounted() {
    this.charger()
    ConventionsApi.sexes().then(reponse => { this.sexes = Array.isArray(reponse) ? reponse : [] }).catch(() => { this.sexes = [] })
  },
  methods: {
    charger() {
      this.chargement = true
      return ConventionsApi.membres(this.assuranceId).then(reponse => {
        this.travailleurs = reponse && Array.isArray(reponse.travailleurs) ? reponse.travailleurs : []
        this.erreur = ''
      }).catch(() => {
        this.erreur = 'La liste des travailleurs n’a pas pu être chargée.'
      }).then(() => {
        this.chargement = false
      })
    },
    basculer(id) {
      this.$set(this.ouverts, id, !this.ouverts[id])
    },
    libelleLien(lien) {
      const trouve = LIENS.find(l => l.valeur === lien)
      return trouve ? trouve.libelle : lien
    },
    avecFiliation(lien) {
      return LIENS_AVEC_FILIATION.indexOf(lien) >= 0
    },
    filiationsProposees(lien) {
      return lien === 'parent' ? ['Père', 'Mère']
        : ['Tante', 'Oncle', 'Cousin', 'Cousine', 'Neveu', 'Nièce', 'Frère', 'Sœur', 'Grand-père', 'Grand-mère', 'Beau-père', 'Belle-mère']
    },
    libelleFamille(t) {
      if (!t.famille.length) return 'Sans famille enregistrée'
      return t.famille.length === 1 ? '1 membre de famille' : t.famille.length + ' membres de famille'
    },
    libelleTauxMembre(membre, travailleur) {
      if (membre.taux !== null && membre.taux !== undefined) return membre.taux + ' %'
      if (travailleur && travailleur.taux !== null && travailleur.taux !== undefined) return travailleur.taux + ' % (travailleur)'
      return 'Taux du contrat'
    },
    peutSupprimer(t) {
      return !t.patient_id && !t.famille.some(m => m.patient_id)
    },
    ouvrir(membre, travailleur) {
      const famille = !!travailleur
      this.formulaire = {
        id: membre ? membre.id : null,
        travailleur_id: famille ? travailleur.id : null,
        nom_travailleur: famille ? (travailleur.nom + ' ' + (travailleur.prenoms || '')).trim() : '',
        lien: membre && famille ? membre.lien : 'enfant',
        filiation: membre && famille ? membre.filiation || '' : '',
        // Membre de la famille : son propre matricule seulement (vide = celui du travailleur).
        matricule: membre ? (famille ? membre.matricule_propre || '' : membre.matricule || '') : '',
        nom: membre ? membre.nom : (famille ? travailleur.nom : ''),
        prenoms: membre ? membre.prenoms || '' : '',
        telephone: membre ? separerTelephone(membre.telephone).numero : '',
        indicatif: membre ? separerTelephone(membre.telephone).indicatif : '',
        sexe_id: membre && membre.sexe_id ? membre.sexe_id : null,
        date_naissance: membre ? membre.date_naissance || '' : '',
        profession: membre ? membre.profession || '' : '',
        quartier: membre ? membre.quartier || '' : '',
        taux: membre && membre.taux !== null && membre.taux !== undefined ? String(membre.taux) : '',
      }
      this.erreur = ''
    },
    paysChoisi(pays) {
      if (this.formulaire && pays && pays.dialCode) this.formulaire.indicatif = '+' + pays.dialCode
    },
    fermer() {
      this.formulaire = null
      this.erreur = ''
    },
    utilisateurId() {
      const info = this.$store ? this.$store.getters['authInfo'] : null
      return info ? info.id : 0
    },
    enregistrer() {
      const f = this.formulaire
      if (!f.nom) {
        this.erreur = 'Le nom est obligatoire.'
        return
      }
      if (!tauxValide(f.taux)) {
        this.erreur = 'Le taux doit être compris entre 0 et 100 %.'
        return
      }
      if (f.travailleur_id && this.avecFiliation(f.lien) && !f.filiation) {
        this.erreur = 'Précisez la filiation (' + (f.lien === 'parent' ? 'père ou mère' : 'tante, oncle, cousin…') + ').'
        return
      }
      this.enregistrement = true
      this.erreur = ''
      const donnees = {
        id: f.id, travailleur_id: f.travailleur_id, lien: f.travailleur_id ? f.lien : 'travailleur',
        filiation: f.travailleur_id && this.avecFiliation(f.lien) ? f.filiation : null,
        matricule: f.matricule, nom: f.nom, prenoms: f.prenoms, telephone: assemblerTelephone(f.indicatif, f.telephone),
        sexe_id: f.sexe_id, date_naissance: f.date_naissance || null, profession: f.profession, quartier: f.quartier,
        taux: f.taux === '' ? null : String(f.taux).replace(',', '.'), user_id: this.utilisateurId(),
      }
      return ConventionsApi.enregistrerMembre(this.assuranceId, donnees).then(() => {
        if (f.travailleur_id) this.$set(this.ouverts, f.travailleur_id, true)
        this.formulaire = null
        if (this.$toasted) this.$toasted.show('Enregistré', { duration: 2500, theme: 'toasted-primary', type: 'success', position: 'top-center' })
        return this.charger()
      }).catch(erreur => {
        this.erreur = messageErreur(erreur, 'L’enregistrement a échoué.')
      }).then(() => {
        this.enregistrement = false
      })
    },
    activer(membre) {
      this.occupe = membre.id
      return ConventionsApi.activerMembre(membre.id, !membre.actif).then(() => this.charger()).catch(erreur => {
        this.erreur = messageErreur(erreur, 'Le changement d’état a échoué.')
      }).then(() => {
        this.occupe = null
      })
    },
    supprimer(membre) {
      if (this.aSupprimer !== membre.id) {
        this.aSupprimer = membre.id
        return
      }
      this.aSupprimer = null
      return ConventionsApi.supprimerMembre(membre.id).then(() => this.charger()).catch(erreur => {
        this.erreur = messageErreur(erreur, 'La suppression a échoué.')
      })
    },
  },
}
</script>

<style scoped>
.convention-carte { padding: 24px; margin-bottom: 20px; border-radius: 18px }
.convention-entete { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 12px; flex-wrap: wrap }
.convention-filtres { display: flex; gap: 12px; margin-bottom: 12px }
.convention-filtres input { flex: 1 }
.convention-filtres select { width: 170px }
.convention-table th { background: #f3f6fc; color: var(--ui-text-secondary, #65728b); border: 0; white-space: nowrap }
.convention-table td { vertical-align: middle; border-top: 1px solid #edf0f6 }
.convention-membre td { background: #fafcff; font-size: 14px }
.convention-membre td:first-child { padding-left: 32px; color: var(--ui-text-secondary, #65728b) }
.convention-deplier { color: var(--ui-text, #304269); font-weight: 600; text-align: left }
.convention-boutons { text-align: right; white-space: nowrap }
.convention-boutons .btn { margin-left: 4px }
.convention-vide { text-align: center; padding: 24px 0; color: var(--ui-text-secondary, #65728b) }
.convention-liens { display: flex; gap: 20px }
.convention-fenetre-contenu .convention-liens label { display: inline-flex; align-items: center; gap: 6px; margin: 0 }
.convention-fenetre { position: fixed; z-index: 1050; inset: 0; display: flex; align-items: center; justify-content: center; background: rgba(30, 40, 64, .45); padding: 16px }
.convention-fenetre-contenu { background: #fff; border-radius: 16px; width: 100%; max-width: 720px; max-height: 90vh; overflow-y: auto; padding: 24px }
.convention-fenetre-contenu .form-group label { display: block }
.convention-fenetre-entete { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; margin-bottom: 16px }
.convention-fenetre-entete h4 { font-size: 22px; line-height: 1.3 }
.convention-fermer { font-size: 24px; line-height: 1 }
@media (max-width: 650px) { .convention-filtres { flex-direction: column } .convention-filtres select { width: 100% } }
</style>
